<div class="container-fluid">
    <div class="row g-6 mb-6">
        <div class="col-xl-12">
            <div class="mainContainer card overflow-auto margin mt-4">
                <div class="loader" *ngIf="loading">
                    <mat-spinner diameter="30"></mat-spinner>
                </div>

                <!-- Header with filters -->
                <div class="reminder mb-0 d-flex bg-light justify-content-between flex-column flex-sm-row">
                    <h5 class="card-title ps-4 mb-0 tableTitle">Activity Logs</h5>

                    <div class="d-flex align-items-center ms-auto me-4 gap-2 flex-wrap">

                        <!-- Search box -->
                        <div class="input-group input-group-sm input-group-inline" style="width: 180px; height: 35px;">
                            <span class="input-group-text pe-2"><i class="bi bi-search"></i></span>
                            <input type="text" class="form-control form-control-sm" placeholder="Search"
                                aria-label="Search" [(ngModel)]="searchText" (keyup)="onSearch()">
                        </div>

                        <!-- Action filter dropdown -->
                        <select class="form-select form-select-sm" style="width: 180px; height: 35px;"
                            [(ngModel)]="selectedAction" (change)="onFilterChange()">
                            <option value="">All Actions</option>
                            <option *ngFor="let action of actionOptions" [value]="action.value">{{ action.label }}
                            </option>
                        </select>

                        <!-- Date filter -->
                        <div class="input-group input-group-sm" style="width: 200px; height: 35px;">
                            <input type="date" class="form-control form-control-sm" [(ngModel)]="selectedDate"
                                (change)="onDateChange()" [max]="today">
                            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="clearDateFilter()"
                                *ngIf="selectedDate" matTooltip="Clear date filter">
                                <i class="bi bi-x"></i>
                            </button>
                        </div>

                        <!-- Month dropdown -->
                        <select class="form-select form-select-sm" style="width: 150px; height: 35px;"
                            [(ngModel)]="selectedMonth" (change)="onMonthYearChange()">
                            <option [ngValue]="null">Month</option>
                            <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
                        </select>

                        <!-- Year dropdown -->
                        <select class="form-select form-select-sm" style="width: 120px; height: 35px;"
                            [(ngModel)]="selectedYear" (change)="onMonthYearChange()">
                            <option [ngValue]="null">Year</option>
                            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                        </select>

                    </div>
                </div>

                <!-- Table -->
                <table matSort class="table table-hover table-nowrap">
                    <thead class="table-light">
                        <tr>
                            <th scope="col">User</th>
                            <th scope="col">Role</th>
                            <th scope="col">Action</th>
                            <th scope="col">Description</th>
                            <th scope="col">IP Address</th>
                            <th scope="col">Date/Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="activityLogs.length > 0">
                            <tr class="dataColumn" *ngFor="let log of activityLogs">
                                <td>{{ log.user_name }}</td>
                                <td>{{ log.user_role }}</td>
                                <td>
                                    <div class="sheetStatus bg-opacity-20" [ngClass]="getActionBadgeClass(log.action)">
                                        <i class="bi" [ngClass]="getActionIcon(log.action)"></i>
                                        <span>{{ getActionLabel(log.action) }}</span>
                                    </div>
                                </td>
                                <td>{{ log.description }}</td>
                                <td>{{ log.ip_address }}</td>
                                <td>{{ dataSharedService.transformTimeDate(log.created_at) }}</td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="activityLogs.length == 0 && !loading">
                            <tr>
                                <td colspan="6" class="text-heading font-bold text-center">No records found</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

                <!-- Pagination -->
                <app-api-paginator *ngIf="totalCount" [totalCount]="totalCount" (onStepChange)="onStepChange($event)">
                </app-api-paginator>
            </div>
        </div>
    </div>
</div>
